import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import i18n from 'i18next'
import Button from '../../UniformComponents/Button'
import { unescapeHtmlTags } from '../../utils/helpers'

@observer
class QuestionSelector extends Component {
    renderQuestions = (chosen = false) => {
        const { DataExplorerStore } = this.props
        const {
            questions, chosenQuestionIds, removeChosenQuestion, getTitle,
        } = DataExplorerStore
        if (!questions || !questions.length) return null
        return questions
            .filter(({ question, parentId }) => chosenQuestionIds.includes(question.formId ? `${parentId}_${question.id}_${question.formId}_` : `${parentId}_${question.id}`) === chosen)
            .map(({
                question, questionOid, titlePrefix, parentId,
            }, index) => (
                <Draggable
                    key={question.formId ? `${parentId}_${question.id}_${question.formId}_` : `${parentId}_${question.id}`}
                    draggableId={question.formId ? `${parentId}_${question.id}_${question.formId}_` : `${parentId}_${question.id}`}
                    index={index}
                    id={question.formId ? `${parentId}_${question.id}_${question.formId}_` : `${parentId}_${question.id}`}
                >
                    {(provided) => (
                        <div
                            className={`dndQuestion ${chosen ? 'chosen' : 'possible'}`}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <div className="draggableQuestion">
                                <div className={`questionColorCode code_${questionOid}`} />
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-Between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fa-solid fa-grip-dots-vertical" />
                                        {unescapeHtmlTags(question.kpiName || getTitle(question, titlePrefix))}
                                    </div>
                                    {chosen
                                        ? (
                                            <i
                                                className="fa-regular fa-circle-xmark"
                                                style={{ float: 'right', cursor: 'pointer' }}
                                                onClick={() => removeChosenQuestion(question.formId ? `${parentId}_${question.id}_${question.formId}_` : `${parentId}_${question.id}`)}
                                            />
                                        )
                                        : null}
                                </div>
                            </div>
                        </div>
                    )}
                </Draggable>
            ))
    }

    onDragEnd = (result) => {
        const { DataExplorerStore } = this.props
        const {
            chosenQuestionIds, addChosenQuestion, removeChosenQuestion,
        } = DataExplorerStore
        if (R.pathOr(false, ['destination', 'droppableId'], result) === 'chosenQuestions'
        && !chosenQuestionIds.includes(result.draggableId)) {
            addChosenQuestion(result.draggableId, result.destination.index)
        }
        if (R.pathOr(false, ['destination', 'droppableId'], result) === 'possibleQuestions'
        && chosenQuestionIds.includes(result.draggableId)) {
            removeChosenQuestion(result.draggableId)
        }
    }

    render() {
        const { DataExplorerStore } = this.props
        const {
            loading, addAllQuestions, questions, chosenQuestionIds,
        } = DataExplorerStore

        if (loading) return <div />
        if (!questions || !questions.length) {
            return (
                <div className="noOptionsSelected">
                    {i18n.t('dataExplorer.noOptions')}
                </div>
            )
        }
        return (
            <div className="questionSelector">
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <div className="questions">
                        <span style={{ fontWeight: '700', fontSize: '14px', marginBottom: '8px' }}>
                            {i18n.t('questions')}
                        </span>
                        <div style={{ minHeight: 0 }}>
                            <div
                                className="questionPanelParent possible"
                            >
                                <div
                                    className="questionPanel"
                                >
                                    <Droppable droppableId="possibleQuestions">
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                style={{ height: 'fit-content', minHeight: '100px' }}
                                            >

                                                {this.renderQuestions()}
                                            </div>
                                        )}
                                    </Droppable>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="questions">
                        <div style={{ width: '100%', flex: 0, marginBottom: '8px' }}>
                            <span style={{ fontWeight: '700', fontSize: '14px' }}>
                                <i className="fa-regular fa-columns-3" style={{ marginRight: '5px', color: '#94E8E3' }} />
                                Rows
                            </span>
                            <div
                                style={{
                                    float: 'right', color: '#4FD2C9', fontSize: '14px', cursor: 'pointer',
                                }}
                                onClick={addAllQuestions}
                            >
                                <i className="fa-regular fa-circle-plus" style={{ marginRight: '5px' }} />
                                Add All
                            </div>
                        </div>
                        <div style={{ minHeight: 0 }}>
                            <div
                                className="questionPanelParent chosenQuestions"
                            >
                                <div
                                    className="questionPanel"
                                >
                                    <Droppable droppableId="chosenQuestions">
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                style={{ height: '100%' }}
                                            >
                                                {this.renderQuestions(true)}
                                            </div>
                                        )}
                                    </Droppable>
                                </div>
                            </div>
                        </div>
                        <Button
                            disabled={!chosenQuestionIds || !chosenQuestionIds.length}
                            style={{ width: '100%', margin: '8px 0 0 0', textAlign: 'center' }}
                            cssClass="secondary regular"
                            onClick={() => DataExplorerStore.getData(true)}
                        >
                            {i18n.t('dataExplorer.runReport')}
                        </Button>
                    </div>
                </DragDropContext>
            </div>
        )
    }
}

export default QuestionSelector
